import { NavLink } from 'react-router-dom';
import { Container } from '@/components/ui';
import { routes } from '@/config/routes';
import { cn } from '@/utils/cn';

export function Header() {
  return (
    <header className="sticky top-0 z-40 border-b border-border bg-background/80 backdrop-blur">
      <Container>
        <nav aria-label="Primary" className="flex h-16 items-center justify-between">
          <NavLink
            to="/"
            className="font-display text-heading-md font-semibold text-foreground"
            aria-label="Clear Lab — home"
          >
            Clear Lab
          </NavLink>
          <ul className="flex items-center gap-6">
            {routes
              .filter((r) => r.showInNav && r.path !== '/')
              .map((r) => (
                <li key={r.path}>
                  <NavLink
                    to={r.path}
                    className={({ isActive }) =>
                      cn(
                        'rounded-sm text-body-sm font-medium transition-colors',
                        isActive ? 'text-brand-700' : 'text-neutral-700 hover:text-foreground',
                      )
                    }
                  >
                    {r.label}
                  </NavLink>
                </li>
              ))}
          </ul>
        </nav>
      </Container>
    </header>
  );
}
